// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_m4-0";